import { HttpProvider } from "../http/http.provider";
import { addProvider } from "../ServiceUtil/providerDescriptors";
import { IProviderDescriptor } from "../ServiceUtil/provider.descriptor.interface";
import { ServiceEndpointConstants } from "../ServiceUtil/consts/index";
import { Observable } from "rxjs";
import { share, map } from "rxjs/operators";
import { IConfig, IConfigCategory, INewConfigItem, IConfigItem } from "./config.interface";
import { IHttpRequestConfig } from "../http/types/http.types";

export class ConfigDelgate {
        constructor(private http: HttpProvider) {
    }

    public getConfig(): Observable<IConfig> {
        return this.http.get(ServiceEndpointConstants.endpoints.CONFIG.CONFIG).pipe(
            map((response: any) => {
                return response.data.config;
            }),
            share());
    }

    public getConfigByOrg(orgId: string): Observable<IConfig> {
        const config: IHttpRequestConfig = {
            params: {
                OrgId: orgId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.CONFIG.CONFIG_BY_ORG, null, config).pipe(
            map((response: any) => {
                return response.data.config;
            }),
            share());
    }
    public getConfigCategories(): Observable<IConfigCategory[]> {
        return this.http.get(ServiceEndpointConstants.endpoints.CONFIG.CONFIG_CATEGORIES).pipe(
            map((response: any) => {
                return response.data.configCategories.configCategories;
            }),
            share());
    }

    public createConfigItem(newConfigItem: INewConfigItem): Observable<IConfigCategory[]> {
        return this.http.post(ServiceEndpointConstants.endpoints.CONFIG.CREATE_CONFIG, newConfigItem).pipe(
            map((response: any) => {
                return response.data.configCategories.configCategories;
            }),
            share());
    }

    public updateConfigItem(configItem: IConfigItem): Observable<IConfigCategory[]> {
        return this.http.post(ServiceEndpointConstants.endpoints.CONFIG.UPDATE_CONFIG, configItem).pipe(
            map((response: any) => {
                return response.data.configCategories.configCategories;
            }),
            share());
    }

}